<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="security-center-wrap">
      <div class="security-center-item">
        <div class="left-area">
          <div class="title">
            <i class="fa-solid fa-key"></i>

            <span>登入密碼</span>
          </div>

          <p>為保證您的帳號安全，建議您定期更改密碼以保護帳號安全。</p>
        </div>

        <div class="right-area">
          <b-button
            variant="secondary"
            v-auth="`update`"
            @click="openUpdatePasswordModal()"
          >
            修改
          </b-button>
        </div>
      </div>
    </div>

    <!-- 更改密碼 modal -->
    <update-password-modal
      v-model="status.updatePasswordModal"
      @sumit="authUpdatePassword" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import baseApi from "@/models/API/baseApi";
import UpdatePasswordModal from"./components/modal/UpdatePasswordModal";

export default {
  name: 'securityCenter',
  components: {
    BreadCrumb,
    UpdatePasswordModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '設定', url: '', isActive: true },
          { name: '安全中心', url: '', isActive: false }
        ]
      },
      status: {
        updatePasswordModal: false,
      },
      data: {
        temp_table_data: {}
      }
    }
  },
  mounted() {
    this.baseApi = new baseApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
    // 開啟更改密碼 modal
    openUpdatePasswordModal() {
      this.status.updatePasswordModal = true;
    },
    // 更改密碼
    authUpdatePassword(from = {}) {
      this.baseApi.authUpdatePassword((response) => {
        const res = response.data;
        let result = '';

        if (res.code === 0) {
          result = { message: '更新成功', title: '安全中心' };
          this.status.updatePasswordModal = false;
        } else if (res.code === 1) {
          result = { message: res.msg, title: '安全中心' };
        }

        this.baseApi.toast(() => {}, result, res.code === 0);
      }, from)
    }
  }
}
</script>

<style lang="scss" scoped>
.security-center-wrap {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  .security-center-item {
    width: 100%;
    min-height: 88px;
    display: flex;
    align-items: center;
    column-gap: 10px;
    border-radius: 4px;
    border: 0.5px solid #D41A30;
    background: transparent;
    padding: 16px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    .left-area {
      flex: 1;
      font-size: 20px;
      .title {
        font-weight: 700;
        margin-bottom: 10px;
      }
      p {
        font-weight: 400;
        margin-bottom: 0;
      }
    }
    .right-area {
      width: 100px;
      button {
        width: 100%;
        height: 40px;
        color: #B03F3F;
        border: 0.5px solid #D41A30;
        background: transparent;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/securityCenter.vue